const Events = require('events')

class ExperimentHooks extends Events {
    constructor() {
        super()
        this.clickAds = getTap(this, 'clickAds')
    }
}

function getTap(/**EventEmitter*/ events, /**string*/ name) {
    return {
        addListener: events.addListener.bind(events, name),
        on: events.on.bind(events, name),
        once: events.once.bind(events, name),
        removeListener: events.removeListener.bind(events, name),
        off: events.off.bind(events, name),
        emit: events.emit.bind(events, name),
    }
}

const experimentHooks = new ExperimentHooks()

export default experimentHooks
